import dayjs from 'dayjs'
import { useState } from 'react'
import { getClientList, getClientUserList } from '../../../../shared/services/ClientUserSetupService'

interface Export {
  chosenColumnNameList: string[]
  pageName: string
  header: string
}

export interface IReqClientUserPayload {
  searchTerm?: string
  searchColumns?: Array<string>
  isDesc?: boolean
  sortColumns?: Array<string>
  pageSize?: number
  pageIndex?: number
  filterOption?: number
  export?: Export
  filterId?: string | null
}

interface IClientUserSetup {
  id: string
  client: string
  lastName: string
  firstName: string
  username: string
  emailAddress: string
  lastLoggedOn: string
  status: number
  userRoles: string[]
  accountNames: string[]
  doNotSendEmailToThisAddress: boolean
  primaryPhone: string
  mobilePhone: string
  clientNotes: string
}

export const useClientUserSetup = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [clientUserList, setClientUserList] = useState<Array<IClientUserSetup>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatClientUserSetupData = (data: any) => {
    const today = dayjs()
    return data?.map((item: any) => {
      let isActionDisabled = false
      if (item?.clientActivationDate && dayjs(item?.clientActivationDate).isBefore(today, 'day')) {
        isActionDisabled = item?.archived
      }
      if (!item?.clientActivationDate && item?.archived) {
        isActionDisabled = true
      }
      return {
        ...item,
        isActionDisabled,
      }
    })
  }

  const getClientUserListData = async (params: IReqClientUserPayload) => {
    try {
      setIsLoading(true)
      const data = await getClientUserList(params)
      setClientUserList(formatClientUserSetupData(data?.data?.items))
      setTotalRecords(data?.data?.total)
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { clientUserList, totalRecords, getClientUserListData, isLoading }
}

export const useClientSelectData = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [clientOptions, setClientOptions] = useState<Array<{ label: string; value: string }>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatResData = (data: any): { label: string; value: string }[] => {
    return data?.map((item: any) => ({
      label: item.clientName,
      value: item.id,
    }))
  }

  const getClientOptions = async () => {
    try {
      setIsLoading(true)

      const data = await getClientList()
      setClientOptions(formatResData(data?.data))
      setTotalRecords(data?.data?.total)

      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { clientOptions, totalRecords, getClientOptions, isLoading }
}

export const formatPhoneNumber = (value: string) => {
  const [countryCode, phoneNumber] = value.split(';#')

  return countryCode ? `(${countryCode}) ${phoneNumber}` : phoneNumber
}
